<template>
  <div>
    <!-- FBA发货计划 -->
    <el-dialog
      :close-on-click-modal="false"
      title="FBA发货计划"
      :visible.sync="visible"
      top="6vh"
      width="1100px"
      class="editDialog"
      :before-close="handleClose"
    >
      <div style="max-height: 54vh;overflow: auto;">
        <div class="order-card" id="edit_deliver">
          <div class="content flex">
            <!-- FBA发货计划 -->
            <!-- FBA发货计划 -->
            <!-- FBA发货计划 -->
            <div class="fl w50">
              <b>货件编号：</b>
              <span>{{ detail.shipmentId }}</span>
            </div>
            <div class="fl w50">
              <b>名称：</b>
              <span>
                {{ detail.planName }}
              </span>
            </div>
            <div class="fl w50">
              <b>计划编号：</b>
              <span>{{ detail.planId }}</span>
            </div>
            <div class="fl w50">
              <b>配送地址：</b>
              <span>
                {{ detail.shipTo }}
              </span>
            </div>
            <div class="fl w50">
              <b>SKU总数：</b>
              <span>{{ detail.totalSkus }}</span>
            </div>
            <div class="fl w50">
              <b>商品总数：</b>
              <span>
                {{ detail.totalUnits }}
              </span>
            </div>
            <div class="fl w50">
              <b>装箱数：</b>
              <span>{{ detail.packingList }}</span>
            </div>
            <div class="fl w50"></div>
          </div>
          <div class="content flex">
            <el-table :data="detail.list" style="width: 100%">
              <el-table-column prop="merchantSku" show-overflow-tooltip label="卖家SKU" width="180">
              </el-table-column>
              <el-table-column prop="title" label="商品名称" show-overflow-tooltip width="180">
              </el-table-column>
              <el-table-column prop="asin" show-overflow-tooltip label="ASIN"> </el-table-column>
              <el-table-column prop="fnsku" show-overflow-tooltip label="FNSKU"> </el-table-column>
              <el-table-column prop="externalId" show-overflow-tooltip label="外部编号"> </el-table-column>
              <el-table-column prop="productStatus" show-overflow-tooltip label="状况"> </el-table-column>
              <el-table-column prop="prep" show-overflow-tooltip label="备货方"> </el-table-column>
              <el-table-column prop="prepType" show-overflow-tooltip label="预处理类型"> </el-table-column>
              <el-table-column prop="labeler" show-overflow-tooltip label="贴标方"> </el-table-column>
              <el-table-column prop="shipped"  show-overflow-tooltip label="已发货"> </el-table-column>
              
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose" size="small">
          关闭
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { queryPlan } from "@/api/order/fba"

export default {
  name: "FbaPlan",
  components: {},
  data() {
    return {
      detail: {},
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    order: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  watch: {
    visible: {
      async handler() {
        if (this.visible) {
          let result = await queryPlan({ shipmentId: this.order.shipmentId })
          this.detail = result.data
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
  },
  methods: {
    handleClose() {
      this.$emit("close")
    },
  },
}
</script>

<style scoped lang="scss">
.center {
  text-align: center;
}

.editDialog {
  font-size: 12px;

  .el-tabs__header {
    margin-bottom: -1px;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #f5f7fa;
    background: #f5f7fa;
  }
}
.order-card {
  margin-bottom: 10px;
  border: 1px solid #ebeef5;

  .title {
    background: #f5f7fa;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    font-weight: bold;
    border-bottom: 1px solid #ebeef5;
    position: relative;

    .right {
      position: absolute;
      right: 10px;
      color: #409eff;
      top: 12px;
      display: flex;
      align-items: center;

      span {
        display: inline-block;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .content {
    width: 100%;
    padding: 20px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #ebeef5;

    &:last-child {
      border: 0;
    }
  }
}

.order-card .content.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 10px;
  flex-wrap: wrap;

  .fl {
    width: 33.33%;
    margin: 2px auto;
    display: flex;
    align-items: center;
    height: 32px;

    b {
      width: 80px;
      text-align: right;
    }
  }
}

.w33 {
  width: 33.33% !important;
}

.w50 {
  width: 50% !important;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px;

  &:last-child {
    margin-bottom: 0;
    border-bottom: 0;
  }

  .left {
    margin-right: 12px;
    width: 100px;
    min-height: 100px;
    margin-bottom: 10px;

    .mini-img {
      width: 95px;
      height: 95px;
      border: 1px solid #ebeef5;
    }

    .id {
      width: 100%;
      text-align: center;
    }
  }
  .right {
    width: 400px;
    padding: 0 0 8px 0;
  }
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.link {
  font-size: 12px;
  color: #1e7ec8;
  cursor: pointer;
}

.step {
  min-height: 300px;
  display: flex;
}

.step {
  .el-steps--vertical {
    width: 100%;
  }
}

.updateDialog {
  display: flex;

  .left {
    width: 100px;
    height: 100px;
    margin-right: 10px;
    border: 1px solid #ebeef5;
  }
}

.updateDialog .left img {
  width: 100%;
  height: 100%;
}

.updateDialog .right {
  display: flex;
  flex-direction: column;

  .title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .list {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .name {
      width: 80px;
    }

    .value {
      width: 100%;
    }
  }
}

#edit_order ::v-deep .el-step {
  flex-basis: 300px !important;
}
</style>
